import {loader} from 'graphql.macro';
import {makeExecutableSchema, addMockFunctionsToSchema} from 'graphql-tools';

import * as branding from './resolvers/branding';
import * as carriers from './resolvers/carriers';
import * as organizations from './resolvers/organizations';
import * as referenceData from './resolvers/referenceData';
import * as scalars from './resolvers/scalars';
import * as shipments from './resolvers/shipments';
import * as users from './resolvers/users';


const typeDefs = loader('./schema.graphql');

const resolvers = {
  ... scalars.resolvers,
  ... branding.resolvers,
  ... carriers.resolvers,
  ... organizations.resolvers,
  ... referenceData.resolvers,
  ... shipments.resolvers,
  ... users.resolvers,
};

const mocks = {
  ... scalars.mocks,
  ... branding.mocks,
  ... carriers.mocks,
  ... organizations.mocks,
  ... shipments.mocks,
};

export const schema = makeExecutableSchema({
  typeDefs,
  resolvers,
});

addMockFunctionsToSchema({
  schema,
  mocks,
  preserveResolvers: true,
});
